import {
    CREATE_EMPLOYEE_REQUEST,
    CREATE_EMPLOYEE_SUCCESS,
    CREATE_EMPLOYEE_FAIL,
    CREATE_EMPLOYEE_RESET,
    CHANGE_EMPLOYEE_REQUEST,
    CHANGE_EMPLOYEE_SUCCESS,
    CHANGE_EMPLOYEE_FAIL,
    CHANGE_EMPLOYEE_RESET,
    GET_EMPLOYEES_REQUEST,
    GET_EMPLOYEES_SUCCESS,
    GET_EMPLOYEES_FAIL
} from '../constants/employeeConstants';

export const employeeCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_EMPLOYEE_REQUEST:
            return { ...state, loading: true, error: null };
        case CREATE_EMPLOYEE_SUCCESS:
            return { ...state, loading: false, createEmployee: action.payload, error: null };
        case CREATE_EMPLOYEE_FAIL:
            return { ...state, loading: false, error: action.payload };
        case CREATE_EMPLOYEE_RESET:
            return { ...state, loading: false, createEmployee: null, error: null };
        default:
            return state;
    }
};

export const employeeChangeReducer = (state = {}, action) => {
    switch (action.type) {
        case CHANGE_EMPLOYEE_REQUEST:
            return { ...state, loading: true, error: null };
        case CHANGE_EMPLOYEE_SUCCESS:
            return { ...state, loading: false, changeEmployee: action.payload, error: null };
        case CHANGE_EMPLOYEE_FAIL:
            return { ...state, loading: false, error: action.payload };
        case CHANGE_EMPLOYEE_RESET:
            return { ...state, loading: false, changeEmployee: null, error: null };
        default:
            return state;
    }
};

export const getEmployeesReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_EMPLOYEES_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_EMPLOYEES_SUCCESS:
            return { ...state, loading: false, employees: action.payload, error: null };
        case GET_EMPLOYEES_FAIL:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};